import React, { FC } from 'react';

export const InnsendingLinje: FC<{text: string, styling?: string}> = (props) => {
  const { text, styling = '' } = props;
  return (<h4 className={styling}>{ text }</h4>);
};
